export enum Extras {
  GEO_NEWSLETTER = 'newsletter',
  GEO_LISTE = 'liste_eventi',
  NEWSLETTER_B2C = 'NEWSLETTER_B2C',
  NEWSLETTER_B2C_CRM_GEO = 'NEWSLETTER_B2C_CRM_GEO',
  NEWSLETTER_B2C_WELCOME_TRAVEL = 'NEWSLETTER_B2C_WELCOME_TRAVEL',
  SERVIZI_DIGITALI_LISTE_IN_VIAGGIO = 'SERVIZI_DIGITALI_LISTE_IN_VIAGGIO',
  ASSICURATA = 'ASSICURATA',
  FONDOGARANZIA = 'FONDOGARANZIA',
  ECOMMERCE_COSTA = 'MODULO_ECOMMERCE_COSTA_CROCIERE',
  ECOMMERCE_AW = "MODULO_ECOMMERCE_ALPITOUR",
  SEKUREST = "SEKUREST",
}
